import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingSpinnerProps {
  /**
   * Size of the spinner
   * @default 60
   */
  size?: number;
  /**
   * Optional loading message to display below the spinner
   */
  message?: string;
  /**
   * Minimum height for the container
   * @default '50vh'
   */
  minHeight?: string | number;
  /**
   * Whether to show the spinner inline (no container)
   * @default false
   */
  inline?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 60,
  message,
  minHeight = '50vh',
  inline = false
}) => {
  if (inline) {
    return <CircularProgress size={size} />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight,
        gap: 2
      }}
    >
      <CircularProgress size={size} />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
};
